export const baseOrderIntentsFields = [
    "created_on_gte",
    "created_on_lte",
    "date_modified_gte",
    "date_modified_lte",
    "retailer_id",
    "buyer_id",
    "ship_start_gte",
    "ship_start_lte",
    "ship_end_gte",
    "ship_end_lte",
    "total_cost_gte",
    "total_cost_lte",
];

export const baseOrderIntentIdFields = ["retailer_id", "buyer_id"];
